export default __webpack_public_path__ + "static/media/icn-load-composition-to-be-reviewed.405b639e.svg";